
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { getFormatedShippingAddress } = require('utilities/cardsHelper');
const { isEmpty } = require('lodash');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
    PERMANENT_ADDRESS_CODE,
    PERMANENT_ADDRESS_TYPE,
    CORRESPONDENCE_ADDRESS_CODE,
    CORRESPONDENCE_ADDRESS_TYPE,
    LAST_ADDED_SHIPPING_ADDRESS_CODE
} = require('constants/shippingAddress');

const getShippingAddressListRequest = () => ({
    type: actionTypes.GET_SHIPPING_ADDRESS_LIST_REQUEST
});

const getShippingAddressListSuccess = (response) => ({
    type: actionTypes.GET_SHIPPING_ADDRESS_LIST_SUCCESS,
    payload: {
        response
    }
});

const getShippingAddressListFailure = (error) => ({
    type: actionTypes.GET_SHIPPING_ADDRESS_LIST_FAILURE,
    payload: {
        error
    }
});

const setShippingAddressType = (addressType) => ({
    type: actionTypes.SET_SHIPPING_ADDRESS_TYPE,
    payload: {
        addressType
    }
})

const setCardShippingAddress = (address) => ({
    type: actionTypes.SET_CARD_SHIPPING_ADDRESS,
    payload: {
        address
    }
})

const resetShippingAddress = () => ({
    type: actionTypes.RESET_CARD_SHIPPING_ADDRESS
})

const setShippingAddress = (addressType, address = {}) => (dispatch) => {
    dispatch(setShippingAddressType(addressType));
    dispatch(setCardShippingAddress(address));
}

const getShippingAddressList = () => (dispatch, getState) => {
    dispatch(getShippingAddressListRequest());

    const  requestData = {
        query : {
            "type": [
                PERMANENT_ADDRESS_CODE,
                CORRESPONDENCE_ADDRESS_CODE,
                LAST_ADDED_SHIPPING_ADDRESS_CODE
            ]
        }
    }
    return APIPost({
        dispatch,
        endpoint : 'getShippingAddressList',
        params : requestData
    })
    .then((response) => {
        dispatch(getShippingAddressListSuccess(response));
        let shippingAddress;
        let addressType;
        let shippingAddressMapping;
        const addressList = getState().shippingAddress;
        const shippingAddressList = addressList.getIn(['shippingAddressList','domicilios']);
        const permanentAddress = shippingAddressList.filter(function(obj) {
            return obj.get('tipoDomicilio') === PERMANENT_ADDRESS_CODE;
        });
        const correspondenceAddress = shippingAddressList.filter(function(obj) {
            return obj.get('tipoDomicilio') === CORRESPONDENCE_ADDRESS_CODE;
        });
        if(correspondenceAddress.size != 0) {
            shippingAddress = correspondenceAddress.get('0');
            addressType = CORRESPONDENCE_ADDRESS_TYPE;
        } else {
            shippingAddress = permanentAddress.get('0');
            addressType = PERMANENT_ADDRESS_TYPE;
        }
        if(!isEmpty(shippingAddress)) {
            shippingAddressMapping = getFormatedShippingAddress(shippingAddress);
        }
        dispatch(setShippingAddress(addressType, shippingAddressMapping));
    }
    )
    .catch((response) => dispatch(getShippingAddressListFailure(response.error)))
}

module.exports = {
    getShippingAddressList,
    resetShippingAddress,
    setShippingAddress
}
